import { StyleSheet } from 'react-native';

const iconSize = 16;
const iconHorizontalPadding = 8;
const iconVerticalPadding = 4;

export const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: 60,
    alignItems: 'center',
    justifyContent: 'center',
  },
  pill: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: 999, // pill shape
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  icon: {
    paddingHorizontal: iconHorizontalPadding,
    paddingVertical: iconVerticalPadding,
  },
  iconButton: {
    width: iconSize + iconHorizontalPadding * 2,
    height: iconSize + iconVerticalPadding * 2,
  },
  iconText: {
    fontSize: 18,
    color: '#00A6A6', // teal color for icon
  },
  countText: {
    fontSize: 16,
    fontWeight: '600',
    marginHorizontal: 12,
  },
});
